<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

/**
 * System Console Page Component
 */
export default {
    page() {
        return {
            title: this.title,
            meta: [{ name: "description" }],
        };
    },
    components: { Layout, PageHeader },
    data() {
        return {
            title: "",
            items: [],
            loading: false,
            userinfo: null,
            tabs: 'log', // 默认显示日志标签页
            devices_list: [],
            log_form: {
                action: "getcommandlogs",
                date: [],
                device: ''
            },
            log_list: [],
            command_loading: false,
            log_page: 1,
            log_limit: 20,
            log_total: 0,
            console_form: {
                device: '',
                type: '',
                command: '',
                net_type: 2,
                pulse: 0
            },
            sendLoading: false,
            console_type: [],
            net_type: []
        };
    },
    computed: {
        consoleTypeOptions() {
            return [
                {
                    type: "at_command",
                    name: this.$t("console.type.at_command")
                },
                {
                    type: "net_type",
                    name: this.$t("console.type.net_type")
                },
                {
                    type: "pulse",
                    name: this.$t("console.type.pulse")
                }
            ];
        },
        netTypeOptions() {
            return [
                {
                    id: 0,
                    name: this.$t("console.net_type.local")
                },
                {
                    id: 1,
                    name: this.$t("console.net_type.wlan")
                },
                {
                    id: 2,
                    name: this.$t("console.net_type.wlan")
                },
                {
                    id: 3,
                    name: this.$t("console.net_type.gprs")
                }
            ];
        }
    },
    mounted() {
        this.title = this.$t("menuitems.console.text");
        this.items = [
            {
                text: this.$t("dashboard.text"),
                href: "/",
            },
            {
                text: this.$t("menuitems.console.text"),
                active: true,
            },
        ];

        try {
            this.userinfo = JSON.parse(localStorage.getItem("user"));
            if (!this.userinfo) {
                this.$message.error(this.$t("global.errors.loginrequired"));
                this.$router.push({ name: "login" });
                return;
            }
        } catch (error) {
            console.error("解析用户信息失败:", error);
            this.$message.error(this.$t("global.errors.loginrequired"));
            this.$router.push({ name: "login" });
            return;
        }

        // 初始化日期范围（昨天到今天）
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        this.log_form.date = [
            yesterday.toISOString().split('T')[0],
            today.toISOString().split('T')[0]
        ];

        this.getdevice_list();
        // 如果默认标签页是日志，则加载日志数据
        if (this.tabs === 'log') {
            this.searchCommandLog();
        }
    },
    methods: {
        switchdatatype() {
            // 切换标签页时的处理
            if (this.tabs === 'log' && this.log_list.length === 0) {
                this.searchCommandLog();
            }
        },
        searchCommandLog() {
            // 确保分页参数正确传递
            if (!this.log_page || this.log_page < 1) {
                this.log_page = 1;
            }
            if (!this.log_limit || this.log_limit < 1) {
                this.log_limit = 20;
            }

            this.command_loading = true;
            const requestData = {
                action: "getcommandlogs",
                page: parseInt(this.log_page),
                limit: parseInt(this.log_limit)
            };

            // 添加日期范围
            if (this.log_form.date && this.log_form.date.length === 2) {
                requestData.date = this.log_form.date;
            }

            // 添加设备筛选
            if (this.log_form.device) {
                requestData.device = this.log_form.device;
            }

            this.$axios
                .post(
                    this.apiuri,
                    requestData,
                    {
                        headers: { Openid: this.userinfo.openid },
                    }
                )
                .then((response) => {
                    this.command_loading = false;
                    if (response.data.status === 200) {
                        // 确保返回的数据是数组
                        this.log_list = Array.isArray(response.data.data) ? response.data.data : [];
                        // 确保总数是数字
                        this.log_total = parseInt(response.data.total) || 0;
                        
                        // 如果返回的数据数量超过 limit，说明后端可能没有正确分页
                        if (this.log_list.length > this.log_limit && this.log_total === 0) {
                            console.warn("后端可能没有正确实现分页，返回了所有数据");
                            // 前端分页作为备选方案
                            const start = (this.log_page - 1) * this.log_limit;
                            const end = start + this.log_limit;
                            this.log_list = this.log_list.slice(start, end);
                            this.log_total = response.data.data ? response.data.data.length : 0;
                        }
                    } else {
                        this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
                        this.log_list = [];
                        this.log_total = 0;
                    }
                })
                .catch((error) => {
                    this.command_loading = false;
                    console.error("获取命令日志失败:", error);
                    this.$message.error(this.$t("global.errors.network"));
                    this.log_list = [];
                    this.log_total = 0;
                });
        },
        handleLogPageChange(page) {
            this.log_page = page;
            this.searchCommandLog();
        },
        handleLogSizeChange(size) {
            this.log_limit = size;
            this.log_page = 1;
            this.searchCommandLog();
        },
        searchLogs() {
            this.log_page = 1;
            this.searchCommandLog();
        },
        getdevice_list() {
            this.$axios
                .post(
                    this.apiuri,
                    {
                        action: "getdevicelist"
                    },
                    {
                        headers: { Openid: this.userinfo.openid },
                    }
                )
                .then((response) => {
                    if (response.data.status === 200) {
                        this.devices_list = response.data.data || [];
                    } else {
                        this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.loaddata"));
                        this.devices_list = [];
                    }
                })
                .catch((error) => {
                    console.error("获取设备列表失败:", error);
                    this.$message.error(this.$t("global.errors.network"));
                    this.devices_list = [];
                });
        },
        sendCommand() {
            // 表单验证
            if (!this.console_form.device) {
                this.$message.error(this.$t("console.device.select_required") || "请选择设备");
                return;
            }
            if (!this.console_form.type) {
                this.$message.error(this.$t("console.command.type_required") || "请选择命令类型");
                return;
            }
            if (this.console_form.type === 'at_command' && !this.console_form.command) {
                this.$message.error(this.$t("console.command.command_required") || "请输入命令内容");
                return;
            }
            if (this.console_form.type === 'pulse' && (!this.console_form.pulse || this.console_form.pulse <= 0)) {
                this.$message.error(this.$t("console.command.pulse_required") || "请输入有效的脉冲值");
                return;
            }

            this.sendLoading = true;
            const postData = {
                action: "sendconsolecommand",
                ...this.console_form
            };

            this.$axios
                .post(
                    this.apiuri,
                    postData,
                    {
                        headers: { Openid: this.userinfo.openid },
                    }
                )
                .then((response) => {
                    this.sendLoading = false;
                    if (response.data.status === 200) {
                        this.$message({
                            message: response.data.msg || this.$t("global.success"),
                            type: "success",
                        });
                        // 重置表单
                        this.console_form.type = '';
                        this.console_form.command = '';
                        this.console_form.pulse = 0;
                        this.console_form.net_type = 2;
                    } else {
                        this.$message.error(response.data.msg || response.data.message || this.$t("global.errors.operation"));
                    }
                })
                .catch((error) => {
                    this.sendLoading = false;
                    console.error("发送命令失败:", error);
                    this.$message.error(this.$t("global.errors.network"));
                });
        },
        resetConsoleForm() {
            this.console_form = {
                device: this.console_form.device, // 保留设备选择
                type: '',
                command: '',
                net_type: 2,
                pulse: 0
            };
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>
                            <i class="el-icon-setting"></i>
                            {{ $t("menuitems.console.text") }}
                        </span>
                    </div>
                    <el-tabs v-model="tabs" type="card" @tab-click="switchdatatype">
                        <!-- 控制台标签页 -->
                        <el-tab-pane :label="$t('menuitems.console.console')" name="console">
                            <el-card style="margin-top: 20px">
                                <div slot="header">
                                    <span>
                                        <i class="el-icon-edit-outline"></i>
                                        {{ $t("console.console.title") || "发送控制台命令" }}
                                    </span>
                                </div>
                                <el-form 
                                    ref="consoleForm" 
                                    :model="console_form" 
                                    label-width="120px"
                                    label-position="left"
                                >
                                    <el-form-item 
                                        :label="$t('console.device.text')"
                                        :rules="[{ required: true, message: $t('console.device.select_required') || '请选择设备', trigger: 'change' }]"
                                    >
                                        <el-select 
                                            v-model="console_form.device" 
                                            filterable
                                            :placeholder="$t('console.device.select') || '请选择设备'"
                                            style="width: 100%"
                                            clearable
                                        >
                                            <el-option 
                                                v-for="item in devices_list" 
                                                :key="item.ED_id" 
                                                :label="item.name"
                                                :value="item.ED_id"
                                            >
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                        :label="$t('console.command.type')" 
                                        v-if="console_form.device"
                                        :rules="[{ required: true, message: $t('console.command.type_required') || '请选择命令类型', trigger: 'change' }]"
                                    >
                                        <el-select 
                                            v-model="console_form.type"
                                            :placeholder="$t('console.command.type') || '请选择命令类型'"
                                            style="width: 100%"
                                            clearable
                                        >
                                            <el-option 
                                                v-for="item in consoleTypeOptions" 
                                                :key="item.type" 
                                                :label="item.name"
                                                :value="item.type"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                        :label="$t('console.console.command')"
                                        v-if="console_form.type == 'at_command'"
                                        :rules="[{ required: true, message: $t('console.command.command_required') || '请输入命令内容', trigger: 'blur' }]"
                                    >
                                        <el-input 
                                            v-model="console_form.command" 
                                            :placeholder="$t('console.console.command_placeholder') || '请输入AT命令'"
                                            clearable
                                        ></el-input>
                                    </el-form-item>
                                    <el-form-item 
                                        :label="$t('console.command.net_type')" 
                                        v-if="console_form.type == 'net_type'"
                                    >
                                        <el-select 
                                            v-model="console_form.net_type"
                                            :placeholder="$t('console.command.net_type') || '请选择网络类型'"
                                            style="width: 100%"
                                        >
                                            <el-option 
                                                v-for="item in netTypeOptions" 
                                                :key="item.id" 
                                                :label="item.name"
                                                :value="item.id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item 
                                        :label="$t('console.console.pulse')"
                                        v-if="console_form.type == 'pulse'"
                                        :rules="[{ required: true, message: $t('console.command.pulse_required') || '请输入脉冲值', trigger: 'blur' }, { type: 'number', min: 1, message: $t('console.command.pulse_min') || '脉冲值必须大于0', trigger: 'blur' }]"
                                    >
                                        <el-input-number 
                                            v-model="console_form.pulse" 
                                            :placeholder="$t('console.console.pulse_placeholder') || '请输入脉冲值'"
                                            :min="1"
                                            :max="9999"
                                            style="width: 100%"
                                        ></el-input-number>
                                    </el-form-item>
                                    
                                    <el-form-item v-if="console_form.device">
                                        <el-button 
                                            type="primary" 
                                            @click="sendCommand"
                                            :loading="sendLoading"
                                            icon="el-icon-s-promotion"
                                        >
                                            {{ $t("console.console.send") }}
                                        </el-button>
                                        <el-button 
                                            @click="resetConsoleForm"
                                            icon="el-icon-refresh"
                                        >
                                            {{ $t("global.button.reset") || "重置" }}
                                        </el-button>
                                    </el-form-item>
                                </el-form>
                            </el-card>
                        </el-tab-pane>

                        <!-- 日志标签页 -->
                        <el-tab-pane :label="$t('menuitems.console.logs')" name="log">
                            <el-card style="margin-top: 20px">
                                <div slot="header">
                                    <span>
                                        <i class="el-icon-document"></i>
                                        {{ $t("console.logs.title") || "命令日志" }}
                                    </span>
                                </div>
                                <el-form 
                                    ref="logForm" 
                                    :model="log_form" 
                                    :inline="true" 
                                    label-width="100px"
                                    style="margin-bottom: 20px"
                                >
                                    <el-form-item :label="$t('statistics.sales.daily.v2')">
                                        <el-date-picker 
                                            v-model="log_form.date" 
                                            type="daterange" 
                                            align="right"
                                            unlink-panels 
                                            :range-separator="$t('statistics.sales.month.to')"
                                            :start-placeholder="$t('statistics.sales.daily.start')"
                                            :end-placeholder="$t('statistics.sales.daily.end')"
                                            value-format="yyyy-MM-dd"
                                            style="width: 100%"
                                        ></el-date-picker>
                                    </el-form-item>
                                    <el-form-item :label="$t('console.device.text')">
                                        <el-select 
                                            filterable 
                                            v-model="log_form.device"
                                            :placeholder="$t('console.device.select') || '请选择设备（可选）'"
                                            clearable
                                            style="width: 200px"
                                        >
                                            <el-option 
                                                v-for="item in devices_list" 
                                                :key="item.ED_id" 
                                                :label="item.name"
                                                :value="item.ED_id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-button 
                                            type="primary" 
                                            @click="searchLogs"
                                            icon="el-icon-search"
                                        >
                                            {{ $t("statistics.sales.search") }}
                                        </el-button>
                                    </el-form-item>
                                </el-form>

                                <el-table 
                                    :data="log_list" 
                                    v-loading="command_loading"
                                    stripe
                                    border
                                    :empty-text="$t('global.text.nodata') || '暂无数据'"
                                    style="width: 100%"
                                >
                                    <el-table-column 
                                        prop="data" 
                                        :label="$t('console.device.command')"
                                        show-overflow-tooltip
                                        min-width="200"
                                    ></el-table-column>
                                    <el-table-column 
                                        prop="time" 
                                        :label="$t('console.device.time')" 
                                        width="180"
                                        align="center"
                                    ></el-table-column>
                                    <el-table-column 
                                        prop="device" 
                                        :label="$t('console.device.id')" 
                                        width="150"
                                        align="center"
                                    ></el-table-column>
                                    <el-table-column 
                                        prop="type" 
                                        :label="$t('console.device.type')" 
                                        width="120"
                                        align="center"
                                    >
                                        <template slot-scope="scope">
                                            <el-tag size="small">{{ scope.row.type || '-' }}</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column 
                                        prop="action" 
                                        :label="$t('console.device.action')" 
                                        width="150"
                                        align="center"
                                    >
                                        <template slot-scope="scope">
                                            <el-tag 
                                                :type="scope.row.action === 'success' ? 'success' : 'danger'" 
                                                size="small"
                                            >
                                                {{ scope.row.action || '-' }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                
                                <!-- 分页组件 -->
                                <div style="margin-top: 20px; text-align: right;" v-if="log_total > 0">
                                    <el-pagination
                                        @size-change="handleLogSizeChange"
                                        @current-change="handleLogPageChange"
                                        :current-page="log_page"
                                        :page-sizes="[10, 20, 50, 100]"
                                        :page-size="log_limit"
                                        layout="total, sizes, prev, pager, next, jumper"
                                        :total="log_total"
                                    ></el-pagination>
                                </div>
                                <div v-else-if="!command_loading" style="text-align: center; padding: 20px; color: #909399;">
                                    <i class="el-icon-info"></i>
                                    {{ $t("console.logs.no_data") || "暂无日志数据" }}
                                </div>
                            </el-card>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.box-card {
    margin-bottom: 20px;
}

.clearfix {
    font-weight: 500;
}

.clearfix i {
    margin-right: 5px;
}
</style>